<template>
  <div :id="id" />
</template>
<script>
export default {
  name: 'Zqrcode',
  props: {
    text: {}
  },
  data() {
    return {
      id: null,
      defaultProp: {
        width: '130',
        height: '130'
      }
    }
  },
  computed: {},
  watch: {
    'text'(newVal) {
      this.refreshQrCode(newVal)
    }
  },
  created() {
    this.refreshQrCode(this.text)
  },
  methods: {
    refreshQrCode(text) {
      if (text) {
        this.id = `zqrcode_${new Date().getTime()}`
        this.$nextTick(() => {
          new QRCode(this.id, { ...this.defaultProp, ...this.$attrs, ...this.$props })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
